import { GridColumnVisibilityModel } from '@mui/x-data-grid-premium'
import { GetControlledTableDefaultState } from '@omnea-app/fe-tables/ControlledTable/hooks/useControlledTableState'

/** Request table columns derived directly from form response */
export const priceFormResponseKeys = ['financeBudget', 'negotiatedSavings', 'costAvoidance'] as const

export const getRequestsTableDefaultState: GetControlledTableDefaultState = () => {
  return {
    columnVisibilityModel: getInitialColumnVisibilityModel(),
    pinnedColumns: {
      left: ['name'],
      right: [],
    },
  }
}

export function getInitialColumnVisibilityModel(): GridColumnVisibilityModel {
  const initialHiddenColumns: string[] = [
    'estimatedCompletionTime',
    'currency',
    'budget',
    'autoGeneratedTags',
    'renewalDate',
    'latestComment',
    'cancelByDate',
    'financeBudget',
    'negotiatedSavings',
    'costAvoidance',
    'isAutoRenewal',
    'productService',
    'completedAt',
    'riskCount',
    'riskScore',
    'department',
    'type',
    'value',
    'costCenter',
    'goLiveDate',
    'renewal',
    'budgetHolder',
    'cancellationReason',
    'contractEndDate',
    'contractStartDate',
    'productService',
    'inBudget',
    'note',
    'poNumber',
    'cancellationNoticeDays',
    'followers',
  ]

  return initialHiddenColumns.reduce((visibilityModel, key) => {
    visibilityModel[key] = false
    return visibilityModel
  }, {} as GridColumnVisibilityModel)
}

export const getInitialColumnVisibility = (hiddenColumns: string[]): Record<string, boolean> => {
  const defaultHiddenColumns = [
    'department',
    'type',
    'value',
    'costCenter',
    'inBudget',
    'businessOwner',
    'budgetHolder',
    'cancellationReason',
    'contractStartDate',
    'contractEndDate',
    'productService',
    'buyerLegalEntity',
    'poNumber',
    'cancellationNotice',
    'note',
    'goLiveDate',
    'followers',
  ]

  const initialHiddenColumns = [...hiddenColumns, ...defaultHiddenColumns, ...priceFormResponseKeys]
  const initialColumnVisibility = initialHiddenColumns.reduce(
    (acc, key) => {
      acc[key] = false
      return acc
    },
    {} as Record<string, boolean>
  )
  return initialColumnVisibility
}
